import * as React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";
import { segmentsPageData } from "../data/page-tpl-segments.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";
import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";
import Hero from "../componentsSections/Hero";
import AnchorNav from "../componentsSections/AnchorNav";
import KeyBenefits from "../componentsSections/KeyBenefits";
import Lottie from "../componentsSections/Lottie";
import ImageSection from "../components/ImageSection";
import SolutionsOverview from "../componentsSections/SolutionsOverview";

const SegmentsPage = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = segmentsPageData(id);
    return (
        <Layout
            pageTitle={seoPageData.title}
            navbarVariant={pageData.hero?.image ? "transparent" : undefined}
        >
            <Seo post={seoPageData} />

            <Hero {...pageData.hero} />
            <Section className="-mobile-full">
                <AnchorNav items={pageData.anchorNav} />
            </Section>

            <Section className="-lottie-spacing">
                <KeyBenefits {...pageData.keyBenefits} />
            </Section>

            <Section className="-mobile-full -lottie-spacing">
                <Lottie {...pageData.tradeLayer} />
            </Section>

            <Section>
                <SolutionsOverview {...pageData.solutionsOverview} />
            </Section>

            <Section className="-mobile-full">
                <ImageSection
                    containerClassName="pt-2"
                    contentClassName="pt-3"
                    imageSection={pageData.imageSection}
                />
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default SegmentsPage;
